import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import { baseUrl } from "./constants";
import components from "./components/*.vue";
import { version } from "../../package.json";
import storeSpecs from "./store/*.js";
import { ResourceManager } from "./engine";

// Register components
Object.keys(components).map(name => Vue.component(name, components[name].default));

// Init store
Vue.use(Vuex);
const store = new Vuex.Store({ modules: Object.keys(storeSpecs).reduce((config, name) => ({ ...config, [name]: storeSpecs[name].default }), {}) });

// Start app
function start() {
    // Init app
    new Vue({ el: "#app", store, render: h => h(App) });
}

// Version check
async function versionCheck() {
    console.log("Current version:", version);
    try {
        // Check version
        const remote = await fetch(`${baseUrl}/version?t=${new Date().getTime()}`).then(res => res.text());
        console.log("Remote version:", remote);
        if (typeof remote == "string" && remote.trim() != version) {
            window.location.reload();
            return false;
        }
    } catch (e) {
        console.log(e);
    }

    return true;
}

// Resume
async function resume() {
    const ok = await versionCheck();
    if (ok) {
        ResourceManager.resume();
    }
}

// Pause
async function pause() {
    ResourceManager.pause();
}

// Start
if (window.cordova) {
    document.addEventListener("deviceready", start, false);
    document.addEventListener("pause", pause, false);
    document.addEventListener("resume", resume, false);
} else {
    window._pause = pause;
    window._resume = resume;
    start();
}
